import React from "react";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import copy from "copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router";

import {
  getSettingState,
  setSnackbarMode,
  setSnackbarTitle,
} from "../../../../redux/features/settingSlice";

const ShareBtn = ({ StyleMenuItem, setAnchorEl }) => {
  const { userData, userName } = useSelector(getSettingState);
  const location = useLocation();
  const dispatch = useDispatch();
  let urlParams = location.pathname.split("/");
  const params = useParams();
  const handleShare = (e) => {
    e.stopPropagation();
    const viewURL = document.location.host;
    copy(viewURL + location.pathname);
    setAnchorEl(null);
    dispatch(setSnackbarMode(true));

    if (urlParams[6] && urlParams[5] === "topics") {
      dispatch(setSnackbarTitle("Topic link copied!"));
      return;
    }
    if (urlParams[3] === "opinions") {
      dispatch(setSnackbarTitle("Opinion link copied!"));
      return;
    }
    if (urlParams[3] === "discussions") {
      dispatch(setSnackbarTitle("discussion link copied!"));
      return;
    }
    if (urlParams[1] === "table") {
      dispatch(setSnackbarTitle("Table link copied!"));
      return;
    }
    if (urlParams[1] === "about") {
      dispatch(setSnackbarTitle("About link copied!"));
      return;
    }
    if (urlParams[1] === "profile") {
      let conCopy = "";
      if (params.profileId) {
        conCopy = params.profileId;
      } else {
        if (userData && userName) {
          conCopy = userName;
        }
      }
      copy(viewURL + "/profile/" + conCopy);
      dispatch(setSnackbarTitle("Profile link copied!"));

      return;
    }
  };

  return (
    <StyleMenuItem onClick={handleShare}>
      <ShareOutlinedIcon sx={{ mb: "3px", mr: "8px" }} /> Share
    </StyleMenuItem>
  );
};

export default ShareBtn;
